import axios, { AxiosResponse } from 'axios'
import { AxiosInstance } from 'axios'
import { ReturnCodeType } from './enum/ReturnCodeType'
import { setErrorPopupData } from '../../domain/errorHandle/util/errorPopupUtil'
import { ErrorType } from '../../domain/errorHandle/model/ErrorType'
import { ApiError } from '../../domain/errorHandle/model/ApiError'
import { useOrderInfoStore } from '../../domain/orderInfo/orderInfoStore'

const backendDomainPrefix = 'bk'
export const getApiEndpointFullyQualifiedDomain = () => {
  const hostname = window.location.hostname
  const parts = hostname.split('.')
  const subdomain = parts[0]
  if (subdomain === 'localhost') {
    return 'bkga7k21mx4bt526r.highplayfky.com'
  }
  else {
    const removedF2EPrefixSubDomain = subdomain.slice(2)
    const mainDomain = parts.slice(1, 3).join('.')
    return `${backendDomainPrefix}${removedF2EPrefixSubDomain}.${mainDomain}`
  }
}

export const commonApiClient: AxiosInstance = axios.create({
  baseURL: `https://${getApiEndpointFullyQualifiedDomain()}/api/common`,
  validateStatus: (status) => {
    return status >= 200 && status < 400
  },
})

export const apiClient: AxiosInstance = axios.create({
  baseURL: `https://${getApiEndpointFullyQualifiedDomain()}/api`,
  validateStatus: (status) => {
    return status >= 200 && status < 400
  },
})

export function setApiAuthToken(token: string) {
  commonApiClient.defaults.headers.common['Authorization'] = `${token}`
  apiClient.defaults.headers.common['Authorization'] = `${token}`
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
export const errorInterceptor = (error) => {
  useOrderInfoStore.getState().clearRecentRefNo()
  if (error.response) {
    const { status } = error.response
    if (error.response.data.errorCode === 21) {
      setErrorPopupData(ErrorType.InsufficientBalance)
      return Promise.reject(new ApiError(ErrorType.InsufficientBalance))
    }
    if (error.response.data.errorCode === 17) {
      setErrorPopupData(ErrorType.BetNotFound)
      return Promise.reject(new ApiError(ErrorType.BetNotFound))
    }
    if (error.response.data.errorCode === 35) {
      setErrorPopupData(ErrorType.VoucherError)
      return Promise.reject(new ApiError(ErrorType.VoucherError))
    }
    if (status === 401) {
      setErrorPopupData(ErrorType.SessionExpired)
      return Promise.reject(new ApiError(ErrorType.SessionExpired))
    }
    setErrorPopupData(ErrorType.SystemError)
    return Promise.reject(ErrorType.SystemError)
  }
  else {
    setErrorPopupData(ErrorType.UnknownSystemError)
    return Promise.reject(new ApiError(ErrorType.UnknownSystemError))
  }
}

export const onResponse = async (response: AxiosResponse) => {
  recentRefNoMiddleware(response)

  const { returnCode } = response.data
  if (returnCode !== 0) {
    const errorType = handleReturnCode(returnCode)
    setErrorPopupData(errorType)
    return Promise.reject(new ApiError(errorType))
  }
  return response
}

export const recentRefNoMiddleware = async (response: AxiosResponse) => {
  const urlLowerCase = response.config.url?.toLowerCase() || ''
  const handleApiNames = ['placeorder', 'buybonus']
  if (handleApiNames.some(apiName => urlLowerCase.includes(apiName))) {
    if (response.data.refNo) {
      useOrderInfoStore.getState().saveCurrentRefNo(response.data.refNo)
    }
    else {
      useOrderInfoStore.getState().clearRecentRefNo()
    }
  }
}

export const handleReturnCode = (returnCode: ReturnCodeType): ErrorType => {
  switch (returnCode) {
    case ReturnCodeType.InternalServerError:
    case ReturnCodeType.InternalError:
    case ReturnCodeType.Unknown:
      return ErrorType.SystemError
      break
    case ReturnCodeType.NoNetWorkError:
      return ErrorType.UnknownSystemError
      break
    case ReturnCodeType.Unauthorized:
    case ReturnCodeType.TokenExpired:
    case ReturnCodeType.BadAuthorization:
      return ErrorType.SessionExpired
      break
    case ReturnCodeType.OverPlayerMaxLose:
      return ErrorType.OverPlayerMaxLose
      break
    case ReturnCodeType.OverMaxBet:
      return ErrorType.OverMaxBet
      break
    case ReturnCodeType.LowerThanMinBet:
      return ErrorType.LowerThanMinBet
      break
    case ReturnCodeType.BetNotFound:
      return ErrorType.BetNotFound
      break
    case ReturnCodeType.BetExisted:
      return ErrorType.BetExisted
      break
    case ReturnCodeType.InsufficientBalance:
      return ErrorType.InsufficientBalance
      break
    case ReturnCodeType.VoucherError:
      return ErrorType.VoucherError
      break
    default:
      return ErrorType.SystemError
      break
  }
}

commonApiClient.interceptors.response.use(onResponse, errorInterceptor)
